import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Timer from "./Timer";
import RetryOrder from "./RetryOrder";
import moment from "moment-timezone";
import socket from "../../socket/socket";

const OngoingOrderList = ({ isBusy, setIsBusy, branchId, status }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [retryOrderId, setRetryOrderId] = useState(null);
  const token = localStorage.getItem("token");

  const fetchOrders = () => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}order/ongoing-order-list?branchId=${branchId}&status=${status}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.code === 1) {
          setOrders(res.data.data);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isBusy === true) {
      fetchOrders();
    }
  }, [isBusy]);

  useEffect(() => {
    socket.on(`admin:ordersUpdate`, (data) => {
      if (data && data?.branchId === branchId) {
        fetchOrders();
      }
    });

    return () => {
      socket.off(`admin:ordersUpdate`);
    };
  }, []);

  return (
    isBusy && (
      <div className="modal fade show d-block" tabIndex="-1" aria-hidden="true">
        {/*begin::Modal dialog*/}
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          {/*begin::Modal content*/}
          <div className="modal-content">
            {/*begin::Modal header*/}
            <div className="modal-header">
              {/*begin::Close*/}
              <h5 className="modal-title">ORDER LIST</h5>
              {/*end::Close*/}
            </div>
            {/*end::Modal header*/}

            {/*begin::Modal body*/}
            <div className="modal-body p-4">
              {/* Loader UI */}
              {loading ? (
                <div className="text-center py-5">
                  <div
                    className="spinner-border text-primary"
                    role="status"
                  ></div>
                  <p className="mt-2">Loading...</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Order Id</th>
                        {status !== "scheduled" && <th>Driver Name</th>}
                        {status !== "scheduled" && <th>Driver Phone</th>}
                        <th>
                          {status === "scheduled" ? "Scheduled At" : "Timer"}
                        </th>
                        <th>Action</th>
                        {status === "-1" && <th>Retry</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {orders?.map((order, index) => (
                        <tr key={index}>
                          <td>{order?.orderId}</td>
                          {status === "scheduled" ? (
                            <td>
                              {moment(order?.scheduledAt)
                                .tz(process.env.REACT_APP_TIMEZONE)
                                .format("Do MMM, YYYY, hh:mm A") ?? "---"}
                            </td>
                          ) : (
                            <>
                              <td>{order?.driverName ?? "---"}</td>
                              <td>{order?.driverPhone ?? "---"}</td>
                              <td style={{ width: "15%" }}>
                                <Timer date={order?.updatedAt} />
                              </td>
                            </>
                          )}

                          <td>
                            <Link
                              target="_blank"
                              to={`/orders/order-details/${order?._id}`}
                            >
                              Details
                            </Link>
                          </td>
                          {status === "-1" && (
                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-primary py-0"
                                onClick={() => setRetryOrderId(order?._id)}
                              >
                                Retry
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {status === "-1" && (
                    <RetryOrder
                      id={retryOrderId}
                      setRetryOrderId={setRetryOrderId}
                    />
                  )}
                </div>
              )}
            </div>
            {/*end::Modal body*/}

            {/*begin::Actions*/}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-danger me-3"
                onClick={() => {
                  setIsBusy(false);
                }}
              >
                Close
              </button>
            </div>
            {/*end::Actions*/}
          </div>
          {/*end::Modal content*/}
        </div>
        {/*end::Modal dialog*/}
      </div>
    )
  );
};

export default OngoingOrderList;
